import apiClient from "./apiClient";

export async function getContainer({
    pageNumber = 0,
    pageSize = 10,
    sortingColumn = 'id',
    direction = 'ASC',
    filters = []
} = {}) {
    const res = await apiClient.post('/minusone-service/container/getContainer', filters, {
        params: { pageNumber, pageSize, sortingColumn, direction },
    });
    return res.data;
}

export async function addOrUpdate(body) {
    const res = await apiClient.post('/minusone-service/container/addOrUpdate', body);
    return res.data;
}

